import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
import TableList from 'components/TableList';
import { ContextMenu } from '../../components/context-menu/context-menu';
import { MessengerBox } from '../../components/messenger-box/messenger-box';
import { Popup } from '../../components/Popup/popup';
import { CheckBox } from '../../components/checkboxes/check-box';
import * as UnitHelper from '../../helper/unit-helper';
import { AppSettings } from '../../constants';
import * as CostCodeActionTypes from '../constants';
import AddEditCostCodeModal from '../Components/add-edit-cost-code-modal';

const defaultParams = {
  defaultSortName: 'name',
  defaultSortOrder: 'ascending',
  sizePerPage: 10
};

let interval = null;

const TABLE_NAME = 'COST_CODE_LIST';

class ManageCostCodes extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    CostCodeStore: PropTypes.object,
    PageSizeReference: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.sizePerPage = UnitHelper.initialSizePerPage(
      TABLE_NAME,
      props.PageSizeReference,
      props.CostCodeStore.ManageCostCodes.params.take
    );

    this.state = {
      sizePerPage: this.sizePerPage,
      isShowPopup: false,
      checkedValues: ['active', 'inActive'],
      editItem: {},
      detectInputSearchInterVal: 0
    };
  }

  componentDidMount() {
    this.getCostCodeList(
      this.objToParams({
        ...this.props.CostCodeStore.ManageCostCodes.params,
        take: this.state.sizePerPage
      })
    );

    setInterval(() => {
      if (this.state.detectInputSearchInterVal === 2) {
        this.setState({ detectInputSearchInterVal: 0 }, () => {
          clearInterval(interval);
          const params = this.objToParams(
            this.props.CostCodeStore.ManageCostCodes.params
          );
          params.searchKey = '';
          params.status = 'all';
          params.skip = 0;
          this.getCostCodeList(params);
          this.search.blur();
        });
      }
    }, 500);

    const self = this;
    window.addEventListener('click', e => {
      if (
        document.getElementById('s1-popup') &&
        document.getElementById('s1-popup').contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById('popup-button') &&
          document.getElementById('popup-button').contains(e.target)
        ) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({ isShowPopup: false });
          }
        }
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sizePerPage !== this.state.sizePerPage) {
      UnitHelper.dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        this.state.sizePerPage
      );
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: CostCodeActionTypes.RESET_COST_CODE });
  }

  getCostCodeList = params => {
    this.props.dispatch({
      type: CostCodeActionTypes.SEARCH_COST_CODE_ASYNC,
      params
    });
  };

  objToParams(obj) {
    return {
      searchKey: this.search.value.trim(),
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      status: obj.status,
      skip: obj.skip,
      take: obj.take
    };
  }

  handleChange = (e, value) => {
    if (this.state.checkedValues.includes(value)) {
      this.setState(
        {
          checkedValues: [
            ...this.state.checkedValues.filter(item => item !== value).sort()
          ]
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    } else {
      this.setState(
        {
          checkedValues: [...this.state.checkedValues, value].sort()
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    }
  };

  onTogglePopupFilter = e => {
    e.preventDefault();
    this.setState({
      isShowPopup: !this.state.isShowPopup
    });
  };

  onSearch(e) {
    e.preventDefault();
    var params = this.objToParams(
      this.props.CostCodeStore.ManageCostCodes.params
    );

    this.setState({
      checkedValues: ['active', 'inActive']
    });

    this.getCostCodeList({
      ...params,
      status: 'all',
      skip: 0
    });
  }

  onChangeInputSearch = e => {
    if (isEmpty(e.target.value)) {
      interval = setInterval(() => {
        this.setState({
          detectInputSearchInterVal: this.state.detectInputSearchInterVal + 1
        });
      }, 1000);
    } else {
      clearInterval(interval);
      this.setState({ detectInputSearchInterVal: 0 });
    }
  };

  onEnter(e) {
    if (e.key === 'Enter') {
      this.onSearch(e);
    }
  }

  onChecked(e, data) {
    var status = UnitHelper.isEmpty(data.toString()) ? '' : data.toString();
    if (status === 'active,inActive') {
      status = 'all';
    }

    var params = this.objToParams(
      this.props.CostCodeStore.ManageCostCodes.params
    );

    this.getCostCodeList({
      ...params,
      status: status,
      skip: 0
    });
  }

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        this.props.dispatch({
          type: CostCodeActionTypes.SEARCH_COST_CODE_ASYNC,
          params: {
            searchKey: '',
            sortField: params.defaultSortName,
            sortOrder: params.defaultSortOrder,
            skip: params.currentPage - 1,
            take: params.sizePerPage
          }
        });
      }
    );
  }

  refreshPageList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        this.props.dispatch({
          type: CostCodeActionTypes.SEARCH_COST_CODE_ASYNC,
          params: {
            searchKey: '',
            sortField: params.defaultSortName,
            sortOrder: params.defaultSortOrder,
            skip: params.currentPage - 1,
            take: params.sizePerPage
          }
        });
      }
    );
  }

  onToggleAddEditModal = (e, editItem) => {
    this.props.dispatch({ type: CostCodeActionTypes.RESET_ERROR_MESSAGE });
    if (editItem) {
      this.setState({
        editItem,
        IsOpenFormAddEdit: !this.state.IsOpenFormAddEdit
      });
    } else {
      this.setState({
        editItem: {},
        IsOpenFormAddEdit: !this.state.IsOpenFormAddEdit
      });
    }
  };

  onCreateCostCode = params => {
    this.props.dispatch({
      type: CostCodeActionTypes.CREATE_COST_CODE_ASYNC,
      params,
      callback: () => {
        this.onToggleAddEditModal();
        this.getCostCodeList(
          this.objToParams(this.props.CostCodeStore.ManageCostCodes.params)
        );
      }
    });
  };

  onEditCostCode = params => {
    this.props.dispatch({
      type: CostCodeActionTypes.EDIT_COST_CODE_ASYNC,
      params,
      callback: () => {
        this.onToggleAddEditModal();
        this.getCostCodeList(
          this.objToParams(this.props.CostCodeStore.ManageCostCodes.params)
        );
      }
    });
  };

  onStyleInactiveItem = item => {
    let style = {};

    if (!item.status) {
      style = { opacity: 0.5 };
    }

    return style;
  };

  customRenderName(item) {
    return <span style={this.onStyleInactiveItem(item)}>{item.name}</span>;
  }

  customRenderCode(item) {
    return <span style={this.onStyleInactiveItem(item)}>{item.code}</span>;
  }

  customRenderBtnAction(item) {
    return (
      <a
        className='glyphicon glyphicon-option-vertical cls-table-black-icon'
        onClick={e => {
          this.onContextMenu(e, item);
        }}
      />
    );
  }

  onContextMenu(e, item) {
    var contextItem = [
      {
        title: 'Edit',
        icon: 'glyphicon glyphicon-pencil',
        event: this.onToggleAddEditModal
      }
    ];

    if (item.status === 1) {
      contextItem.push({
        title: 'Make inactive',
        icon: 'glyphicon glyphicon-minus-sign',
        event: this.onMakeCostCodeInactive.bind(this)
      });
    } else {
      contextItem.push({
        title: 'Make active',
        icon: 'glyphicon glyphicon-ok-sign',
        event: this.onMakeCostCodeActive.bind(this)
      });
    }

    this.cxtMenu.state.event(e, item, contextItem);
  }

  onMakeCostCodeActive = (e, item) => {
    this.props.dispatch({
      type: CostCodeActionTypes.MAKE_COST_CODE_ACTIVE_ASYNC,
      params: {
        id: item.id
      },
      callback: () => {
        this.getCostCodeList(
          this.objToParams({
            ...this.props.CostCodeStore.ManageCostCodes.params,
            take: this.state.sizePerPage
          })
        );
      }
    });
  };

  onMakeCostCodeInactive = (e, item) => {
    this.props.dispatch({
      type: CostCodeActionTypes.MAKE_COST_CODE_INACTIVE_ASYNC,
      params: {
        id: item.id
      },
      callback: () => {
        this.getCostCodeList(
          this.objToParams({
            ...this.props.CostCodeStore.ManageCostCodes.params,
            take: this.state.sizePerPage
          })
        );
      }
    });
  };

  render() {
    const { items, params } = this.props.CostCodeStore.ManageCostCodes;
    const data = items;

    const column = [
      {
        field: 'id',
        header: 'id',
        hidden: true,
        isKey: true,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left'
      },
      {
        field: 'name',
        header: 'Name',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        columnClassName: 'td-width-60-percent',
        customRender: this.customRenderName.bind(this)
      },
      {
        field: 'code',
        header: 'Cost code',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        customRender: this.customRenderCode.bind(this)
      },
      {
        field: '',
        header: '',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'right',
        headerAlign: 'right',
        customRender: this.customRenderBtnAction.bind(this)
      }
    ];

    const options = {
      defaultSortName: params.sort.field, // default sort column name
      defaultSortOrder: params.sort.order, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: params.totalRecord
    };

    const customHeader = (
      <div className='table-header'>
        <Row>
          <Col sm={12} md={12} className='text-right'>
            <div className='box-search'>
              <div className='input-group'>
                <input
                  type='text'
                  id='txt-search-email'
                  ref={ref => {
                    this.search = ref;
                  }}
                  className='form-control'
                  onChange={this.onChangeInputSearch}
                  placeholder='Search'
                  onKeyPress={this.onEnter.bind(this)}
                />
                <span className='input-group-btn'>
                  <button
                    onClick={this.onSearch.bind(this)}
                    className='btn btn-secondary'
                  >
                    <span className='fa fa-search' aria-hidden='true' />
                  </button>
                </span>
              </div>
            </div>

            <div className='manage-user-filter pull-right'>
              <button
                onClick={this.onTogglePopupFilter}
                className='btn btn-secondary fa fa-filter btn-icon'
                id='popup-button'
              />
              {this.state.isShowPopup && (
                <Popup
                  ref={ref => {
                    this.popup = ref;
                  }}
                >
                  <CheckBox
                    checked={this.state.checkedValues.includes('active')}
                    onChecked={this.onChecked.bind(this)}
                    name='isActive'
                    className='checkbox-default'
                    value='active'
                    label='Active'
                    handleChange={this.handleChange}
                  />
                  <CheckBox
                    checked={this.state.checkedValues.includes('inActive')}
                    onChecked={this.onChecked.bind(this)}
                    name='isActive'
                    className='checkbox-default'
                    value='inActive'
                    label='InActive'
                    handleChange={this.handleChange}
                  />
                </Popup>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );

    return (
      <div id='manage-user'>
        <div className='page-title clearfix'>
          <h2 className='pull-left'>Cost codes ({params.totalRecord})</h2>
          <button
            className='btn btn-primary btn-info btn-siteone pull-right btn-icon'
            onClick={this.onToggleAddEditModal}
          >
            <span className='fa fa-plus icon' />
            NEW
          </button>
        </div>
        <ContextMenu
          ref={ref => {
            this.cxtMenu = ref;
          }}
        />
        <MessengerBox
          ref={ref => {
            this.msgBox = ref;
          }}
          title={AppSettings.COMPANY_NAME}
        />

        <AddEditCostCodeModal
          item={this.state.editItem}
          errorMsg={this.props.CostCodeStore.ErrorMsg}
          isOpen={this.state.IsOpenFormAddEdit}
          isCreate={this.state.IsCreate}
          onCreateCostCode={this.onCreateCostCode}
          onEditCostCode={this.onEditCostCode}
          onCloseModal={this.onToggleAddEditModal}
        />

        <TableList
          ref={ref => {
            this.tableList = ref;
          }}
          column={column}
          defaultParams={defaultParams}
          data={data}
          options={options}
          refreshPageList={this.refreshPageList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          customTableHeader={customHeader}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    CostCodeStore: state.CostCodeStore,
    PageSizeReference: state.BuilderStore.PageSizeReference
  };
};

export default connect(mapStateToProps)(ManageCostCodes);



// WEBPACK FOOTER //
// ./src/CostCodes/Containers/manage-cost-code.js